import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import styles from './Markdown.scss'

const Markdown = ({ source = '' }) => <ReactMarkdown source={source} className={styles.Markdown} />
Markdown.propTypes = {
  source: PropTypes.any.isRequired,
}
export default Markdown



// WEBPACK FOOTER //
// ./src/components/Markdown/Markdown.js